import { Expose, Type } from 'class-transformer';
import { SpaceBuildingLocationDto } from './space-building-location.dto';

export class SpaceBuildingDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'number' })
  number: string;
  @Expose({ name: 'address_id' })
  addressId: number;
  @Expose({ name: 'location_id' })
  locationId: number;
  @Expose({ name: 'code' })
  code: string;
  @Expose({ name: 'location' })
  @Type(() => SpaceBuildingLocationDto)
  location: SpaceBuildingLocationDto;
}
